export default __webpack_public_path__ + "static/media/Grupo6134.3f45a9a7.svg";